import LanguageType from "@/constant/languages";
import storage from "../local_storage";
import storageKey from "@/constant/storage_key";

export default function() {
    const storageLanguage = storage.get(storageKey.USER_LANGUAGE_KEY)
    const local = storageLanguage ?? window.navigator.language;
    switch(local) {
        case LanguageType.zh_CN:
        case LanguageType.zh:
            storage.set(storageKey.USER_LANGUAGE_KEY, 'zh');
            document.title = "云凝数科";
            return 'zh';
        case LanguageType.en_GB:
        case LanguageType.en_US:
        case LanguageType.en:
            storage.set(storageKey.USER_LANGUAGE_KEY, 'en');
            document.title = "Air & Liquid Cooling Technology Limited";
            return 'en';
        default: return 'zh'
    }
}